import React from 'react';
import cls from 'classname';

export const ShopifyBtnIcon = ({ width, height, className, theme }) =>
  <svg width={width ? width : '24'}
       height={height ? height : '24'}
       viewBox="0 0 24 24"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
       className={cls('icon icon-shopify',className)}
  >
    <path
      d="M17.9 5.9C17.9 5.8 17.8 5.7 17.7 5.7C17.6 5.7 16.3 5.7 16.3 5.7C16.3 5.7 15.1 4.5 15 4.4C14.9 4.3 14.7 4.3 14.6 4.3C14.6 4.3 14.4 4.4 14 4.5C13.9 4.3 13.9 4 13.7 3.8C13.3 3 12.7 2.6 12 2.6C11.9 2.6 11.9 2.6 11.8 2.6C11.8 2.6 11.8 2.5 11.7 2.5C11.5 2.2 11.1 2 10.6 2C9.7 2 8.7 2.7 8 4C7.5 4.9 7.1 6 7 6.8C5.9 7.1 5.1 7.4 5.1 7.4C4.6 7.6 4.5 7.6 4.5 8.1C4.4 8.5 3 19.9 3 19.9L14.9 22L20 20.7C20 20.7 17.9 6 17.9 5.9ZM13.4 4.7C13.2 4.8 12.8 4.9 12.5 5C12.5 4.5 12.4 3.8 12.2 3.2C12.9 3.4 13.3 4.2 13.4 4.7ZM11.9 5.2C11.3 5.4 10.6 5.6 9.9 5.8C10.1 5 10.5 4.3 10.9 3.8C11.1 3.6 11.3 3.4 11.6 3.3C11.8 3.9 11.9 4.7 11.9 5.2ZM10.6 2.6C10.8 2.6 11 2.6 11.2 2.8C10.9 2.9 10.7 3.1 10.5 3.4C9.9 4 9.4 5.1 9.2 6.1C8.7 6.2 8.1 6.4 7.6 6.6C7.9 5 9.2 2.7 10.6 2.6Z"
      fill={theme === 'dark' ? '#E2E6F3' : '#F2F6FF'}/>
    <path
      d="M17.3004 5.70005C17.2004 5.70005 16.2004 5.70005 16.2004 5.70005C16.2004 5.70005 15.8004 5.10005 15.6004 5.00005C15.6004 5.00005 15.0004 4.30005 14.9004 4.30005V22L20.0004 20.7001C20.0004 20.7001 17.9004 5.90005 17.9004 5.80005C17.8004 5.60005 17.4004 5.70005 17.3004 5.70005Z"
      fill={theme === 'dark' ? '#F2F6FF' : '#FFFFFF'}/>
    <path
      d="M12 8.1999L11.4 10.4999C11.4 10.4999 10.7 10.1999 9.9 10.1999C8.7 10.2999 8.7 10.9999 8.7 11.1999C8.8 12.1999 11.5 12.3999 11.6 14.7999C11.7 16.6999 10.6 17.8999 9 17.9999C7.1 18.0999 6 16.9999 6 16.9999L6.4 15.2999C6.4 15.2999 7.5 16.0999 8.3 15.9999C8.9 15.9999 9.1 15.4999 9 15.1999C9 13.8999 6.8 13.9999 6.7 11.7999C6.6 9.9999 7.8 8.1999 10.4 7.9999C11.5 7.8999 12 8.1999 12 8.1999Z"
      fill={theme === 'dark' ? '#225AEA' : '#225AEA'}/>
  </svg>
;

export default ShopifyBtnIcon;
